import React from 'react'
import {Field} from "./index";
import Utils from "../../utils";
import {Col} from "antd";


export class FieldLine extends Field {

  constructor(obj={}) {
    super(obj);
  }

  getComponent () {
    return () => (
      <Col xs={24} sm={24} md={this.size}>
        <div></div>
      </Col>);
  }

  transformToField = (data) => {
    this.type = data.type;
    this.size = 24;
    return this;
  }
}